/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import useStyles from './useStyles';
import FireboardUtils from '../../util/fireboard-util';
import { version } from '../../../package.json';

const About = ({ open, onClose }) => {
  const { storeInfo, deviceApi, currencyInfo, labelsData } = useSelector(state => state);
  const labels = labelsData.labels;
  const { supportPhoneNumber, name: storeName, } = storeInfo?.data || {};
  const { deviceName, deviceGroup } = deviceApi?.data || {};
  const { iso2, rnDevEnv } = currencyInfo || {};
  const baseUrl = window.location.origin || '';
  const classes = useStyles();

  const getEnv = () => {
    const envMode = process.env.REACT_APP_MODE;
    switch (envMode) {
      case 'DEV': return labels?.ABOUT_POPUP_DEVELOPMENT;
      case 'UAT': return labels?.ABOUT_POPUP_UAT;
      case 'STAGE': return labels?.ABOUT_POPUP_STAGE;
      default: return labels?.ABOUT_POPUP_PRODUCTION;
    }
  };

  const AboutConfigs = [
    { label: labels?.ABOUT_POPUP_STORE_NAME, key: 'storeName', value: storeName, display: true, },
    { label: labels?.ABOUT_POPUP_DEVICE_NAME, key: 'deviceName', value: deviceName, display: true, },
    { label: labels?.ABOUT_POPUP_DEVICE_GROUP_NAME, key: 'deviceGroupName', value: deviceGroup?.name || '', display: true, },
    { label: labels?.ABOUT_POPUP_WEB_VERSION, key: 'webVersion', value: version, display: (window.ReactNativeWebView && rnDevEnv) || (!window.ReactNativeWebView), },
    { label: labels?.ABOUT_POPUP_ENVIRONMENT, key: 'environment', value: getEnv(), display: true, },
    { label: labels?.ABOUT_POPUP_FOR_SUPPORT, key: 'forSupport', value: FireboardUtils.formattedPhoneNumber(supportPhoneNumber, iso2), display: true, },
    { label: labels?.ABOUT_POPUP_DOORDASH_DRIVE_DELIVERY, key: 'doordashDriveDelivery', value: '(855) 973-1040', display: true, },
    { label: labels?.ABOUT_POPUP_DOORDASH_MARKETPLACE, key: 'doordashMarketplace', value: '(855) 973-1040', display: true, },
    { label: labels?.ABOUT_POPUP_GRUBHUB_MARKETPLACE, key: 'grubhubMarketplace', value: '(877) 585-7878', display: true, },
    { label: labels?.ABOUT_POPUP_UBEREATS_MARKETPLACE, key: 'ubereatsMarketplace', value: '(833) 275-3287', display: true, },
    { label: labels?.ABOUT_POPUP_URL, key: 'url', value: baseUrl, display: window.ReactNativeWebView && rnDevEnv, },
  ];

  return (
    <Dialog
      open={open}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minHeight: '40%',
          minWidth: '35%',
        }
      }}
    >
      <DialogTitle id="dialog-title" className={classes.dialogTitleContainer} disableTypography>
        <Typography variant="body1" className={classes.dialogTitle}>{labels?.ABOUT_POPUP_ABOUT}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        {AboutConfigs.map(info =>
          info.display && (
            <Box key={info.key} display={'flex'} alignItems={'center'} mb={1.5} mt={0.5}>
              <Typography variant='body2' className={classes.labelTxt}>{info.label}</Typography>
              <Typography variant='body2' className={classes.valueTxt}>{info.value}</Typography>
            </Box>
          ))}
      </DialogContent>
    </Dialog>
  );
};

export default About;
